export const BACKSPACE_CODE = 'Backspace';
export const DELETE_CODE = 'Delete';
